import { useEffect, useState } from "react";
import api from "@/lib/api";

/*
 * Inima Colectivă — pulsul emoțional agregat al comunității (anonim, min. prag).
 * Bate mai liniștit în zilele bune, mai grăbit în cele grele. Culoare blândă,
 * niciodată roșu alarmant. Text = „vremea emoțională" a zilei.
 */
const COLORS = {
  auriu: "#d9a441",
  albastru: "#6b93b8",
  "gri-bland": "#9aa39d",
};

export default function Pulse({ compact = false }) {
  const [pulse, setPulse] = useState(null);

  useEffect(() => {
    const load = () => api.get("/public/pulse").then((r) => setPulse(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000); // reîmprospătare pt Bătaia de Aur
    return () => clearInterval(t);
  }, []);

  if (!pulse) return null;
  const gold = pulse.gold_beat;
  const color = gold ? "#d9a441" : (COLORS[pulse.color] || COLORS.albastru);
  const dur = gold ? "0.9s" : pulse.rhythm === "grabit" ? "1.1s" : pulse.rhythm === "asezat" ? "1.7s" : "2.3s";

  return (
    <div className={`flex items-center gap-4 ${compact ? "" : "justify-center flex-col text-center"}`} data-testid="pulse">
      <div className="relative">
        {gold && (
          <span className="absolute inset-0 rounded-full" style={{ boxShadow: "0 0 40px 10px rgba(217,164,65,0.5)", animation: "ctBreathe 0.9s ease-in-out infinite" }} />
        )}
        <svg viewBox="0 0 48 48" width={compact ? 36 : 52} height={compact ? 36 : 52} aria-hidden className="relative">
          <path
            d="M24 42 C 8 30, 4 18, 12 12 C 18 8, 24 14, 24 18 C 24 14, 30 8, 36 12 C 44 18, 40 30, 24 42 Z"
            fill={color}
          >
            <animateTransform attributeName="transform" type="scale" values="1;1.12;1" dur={dur} repeatCount="indefinite" additive="sum" />
            <animate attributeName="opacity" values="0.85;1;0.85" dur={dur} repeatCount="indefinite" />
          </path>
        </svg>
      </div>
      {gold ? (
        <p className={compact ? "text-xs" : "text-sm max-w-md"} style={{ color: "#b0862e", fontWeight: 500 }}>{pulse.gold_text}</p>
      ) : pulse.enough_data ? (
        <p className={compact ? "text-xs" : "text-sm max-w-md"} style={{ color: "var(--ct-text-muted)" }}>{pulse.weather}</p>
      ) : (
        <p className={compact ? "text-xs" : "text-sm"} style={{ color: "var(--ct-text-muted)" }}>{pulse.message}</p>
      )}
    </div>
  );
}
